import {
  bool as boolType,
  arrayOf as arrayType,
  string as stringType,
  shape as shapeType,
  number,
  params
} from '@thd-nucleus/data-sources';
import { ShopByRoomPod } from '../shop-by-room/ShopByRoomPod';

export const CurationDataModel = {
  curation: params({
    curationId: arrayType(stringType().isRequired()),
    storeId: stringType(),
    pageSize: number(),
    startIndex: number(),
    preview: boolType()
  }).arrayOf(shapeType({
    metadata: shapeType({
      productCount: shapeType({
        allProducts: stringType()
      }),
      name: stringType()
    }),
    products: arrayType(shapeType(ShopByRoomPod.dataModel.product))
  }))
};
